import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { SVGProfile, SVGTreeDots } from "../assets/PackageSVG";
import styles from "./UserProfile.module.scss";

export const UserProfile = ({ collapsed = false }: { collapsed?: boolean }) => {
    const { user, isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const navigate = useNavigate();

    if (isLoading) {
        return <div className={styles.loading}>Loading ...</div>;
    }

    if (!isAuthenticated) {
        return (
            <div className={styles.loginWrapper}>
                <button
                    className={`${styles.loginBtn}${collapsed ? ` ${styles.loginBtnCollapsed}` : ''}`}
                    onClick={() => loginWithRedirect()}
                    type="button"
                >
                    <SVGProfile width="16" height="16" />
                    {!collapsed && 'Log in'}
                </button>
            </div>
        );
    }

    const name = (user?.nickname || user?.name || user?.email || 'User') as string;

    // On the icon rail there is no room for the name row, so the avatar
    // goes straight to the profile page, same as the "…" button does when
    // expanded.
    if (collapsed) {
        return (
            <div className={styles.wrapperCollapsed}>
                <button
                    className={styles.avatarBtn}
                    type="button"
                    onClick={() => navigate('/profile')}
                    title={name}
                >
                    {user?.picture
                        ? <img className={styles.avatarImg} src={user.picture} alt="" />
                        : <SVGProfile width="18" height="18" />}
                </button>
            </div>
        );
    }

    return (
        <div className={styles.card}>
            <div className={styles.left}>
                <span className={styles.icon}>
                    {user?.picture
                        ? <img className={styles.avatarImg} src={user.picture} alt="" />
                        : <SVGProfile width="18" height="18" />}
                </span>
                <span className={styles.text}>
                    <span className={styles.name}>{name}</span>
                    <small className={styles.meta}>Signed in</small>
                </span>
            </div>
            <button
                className={styles.dotsBtn}
                type="button"
                aria-label="Open profile"
                onClick={() => navigate('/profile')}
            >
                <SVGTreeDots width="14" height="14" />
            </button>
        </div>
    );
}
